<template>
  <div class="drop-ghost"></div>
</template>

<script setup>
// No props or logic needed - this is a pure visual component
</script>

<style scoped>
.drop-ghost {
  border: 1px dashed grey;
  background-color: rgba(200, 200, 255, 0.3);
  height: 5px;
  width: 100%;
  box-sizing: border-box;
  pointer-events: none;
  transition: all 0.2s ease;
}
</style>
